import { Box, useTheme } from '@material-ui/core';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import { IntelligenceIcon } from '@setvi/shared/components/sicons';
import { TextColor } from '@setvi/shared/enums';
import { Divider, Wrapper } from '../styled';
import { DrawerHeaderTitle } from '../../../drawer-content/components';
import { HeaderProps } from '../..';

export const AIHeader = ({
  showAIInput,
  feedback,
  closeAISearchMode
}: Pick<HeaderProps, 'showAIInput' | 'closeAISearchMode' | 'feedback'>) => {
  const { palette } = useTheme();

  const props = !showAIInput
    ? {
        color: TextColor.Black,
        title: 'Ask AI',
        closeIcon: <ArrowBackIosIcon style={{ fontSize: 12 }} />,
        titleIcon: <IntelligenceIcon />
      }
    : {
        title: 'Close Ask AI',
        color: TextColor.Blue
      };

  return (
    <>
      <Wrapper
        py={2}
        px="20px"
        height={56}
        style={{ backgroundColor: palette.common.white }}>
        <DrawerHeaderTitle handleClose={closeAISearchMode} {...props} />
        {!showAIInput && (
          <Box display="flex" gridGap={8}>
            {feedback}
            {/* {viewModeToggler} */}
          </Box>
        )}
      </Wrapper>
      <Divider />
    </>
  );
};
